export const SECTION_LIST = {
  DASHBOARD: 'dashboard',
  PRODUCTS: 'products',
  COUPONS: 'coupons',
  CATEGORIES: 'categories',
  TAGS: 'tags',
  ATTRIBUTES: 'attributes',
  COMMENTS: 'comments',
  ORDERS: 'orders',
  CUSTOMERS: 'customers',
  SKU: 'SKU-management',
  BILL: 'billing',
  WAREHOUSES: 'warehouses',
  WAREHOUSE_OPERATION: 'operations',
  PROMOTION: 'promotion',
}
